export const imageTransform = (url: any, width: any, height: any) => {
  if (!url) {
    return ''
  }
  let isRetina = false
  if (typeof window !== 'undefined') {
    const mq = window.matchMedia(
      'only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)',
    )
    isRetina = (mq && mq.matches) || window.devicePixelRatio > 1
  }
  const SCALE = isRetina ? 2 : 1
  if (url.indexOf('img.teamfeedr.com') !== -1) {
    const [pre, post] = url.split('img.teamfeedr.com')
    return `${pre}img.teamfeedr.com/cdn-cgi/image/width=${width * SCALE},height=${
      height * SCALE
    },quality=100,format=auto,fit=cover${post}`
  }
  if (url.indexOf('cloudinary') !== -1) {
    const [pre, post] = url.split('/image/upload/')
    return `${pre}/image/upload/w_${width * SCALE},h_${height * SCALE},c_fill/${post}`
  }
  return url
}
